<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>教学管理</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
       <div class="conten">
          <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
                 教学管理查询
            </template>
            <p class="text">教学管理界面显示当前教师所创建的所有课程，课程教学方式分为“自主学习”和“直播授课”，上架状态分为“已上架”和“未上架”，课程状态分为“未开始”、“进行中”、“已结束”，其中自主学习的课程无课程时间以及课程状态。可通过上架状态（未上架、已上架）、课程状态（所有、未开始、进行中、已结束）以及课程名称模糊查询已存在的课程，默认一页显示30条。</P>
             <div><img src="../../../../static/image/93.png"/></div>
          </el-collapse-item>
          <el-collapse-item title="新建教学课程">
            <P class="text">教师可在此新建教学课程。</P>
            <p class="text"> 步骤一：用户点击【新建课程】，在新建课程界面，完善基本信息的输入。</p>
            <p class="text"> 步骤二：选择教学方式，默认为直播授课。</p>
            <p class="text"> 步骤三：【是否公开】默认公开，开放范围不显示；【是否公开】选择为【私人】时，需选择开放范围。</p>
            <p class="text"> 步骤四：添加影像、病历、附件。</p>
            <P class="text">点击【保存】按钮，新建课程成功，或者点击【直接上架】按钮，新建课程成功并直接上架。</P>
            <div><img src="../../../../static/image/94.png"/></div>
          </el-collapse-item>
          <el-collapse-item title="教学课程上架下架">
            <P class="text"><b>上架：</b>选中一条或者多条【未上架】的课程，点击<b><img  class="littleImg"  src="../../../../static/image/95.png"/></b>按钮，课程上架成功，上架状态由【未上架】变为【已上架】。</P>
            <p class="text">【已上架】的课程可在教学中心被查看到。</p>
            <P class="text">下架：选中一条或者多条【已上架】的课程，点击<b><img  class="littleImg"  src="../../../../static/image/96.png"/></b>按钮，课程下架成功，上架状态由【已上架】变为【未上架】。上架状态为【已上架】、课程状态为【进行中】的课程不允许下架。</P>
            <p class="text">【未上架】的课程不可在教学中心被查看到。</p>
          </el-collapse-item>
            <el-collapse-item title="教学课程查看">
            <P class="text">在操作列表处点击<b><img  class="ltImg"  src="../../../../static/image/78.png"/></b>，进入查看课程界面。</P>
            <div><img src="../../../../static/image/97.png"/></div>
            <p class="text">区域1:包含此课程的基本信息以及观看量、评价量、点赞量以及收藏量。</p>
            <P class="text">区域2：包含相关影像、病例、附件以及学员对此课件的评价，可通过tab页切换。</P>
            <p class="text"><b>直播授课：</b>中只有上架状态为【已上架】、课程状态为【进行中】的课程才可进入课程，否则“进入课程”按钮置灰；</p>
            <p class="text"><b>自主学习：</b>课程上架状态为【已上架】即可进入课程。</p>
          </el-collapse-item>
        </el-collapse>

      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
 .rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
    overflow:auto
  .conten
     padding: 25px 25px 25px 30px
  .titleBar
     color:#000
     font-size:14px
     font-weight:bolder
  .text
     color:#555
     line-height: 25px
     text-indent:2em
  .textlittle
    text-indent:3em
  img
    width:80%
  .ltImg
    width:30px

  .littleImg
      width:65px
      vertical-align:middle
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px

</style>



// WEBPACK FOOTER //
// ManageTeach.vue?803a9b92